import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin';

const isHierarchy = true; // expects true or false injected by plop

export const InMarketHierarchyCreate = (props) => {
    const defaultReferenceSort = { field: "name_path", order: "ASC" }
    return (
    <Create {...props}>
        <SimpleForm redirect='list'>
            <TextInput fullWidth label="In Market Hierarchy Name" source="text" />
            {(isHierarchy) && <ReferenceInput
                reference="kelloggs_in_market_hierarchy"
                source="parent"
                perPage={500}
                fullWidth
                sort={defaultReferenceSort}
                filterToQuery={(searchText) => ({ 'name_path@ilike':  `${encodeURIComponent(searchText)}` })}
            >
            <SelectInput
                optionText="name_path"
            />
            </ReferenceInput>}
        </SimpleForm>
    </Create>
)};
export default InMarketHierarchyCreate